// extracted by mini-css-extract-plugin
export default {"btn":"WhiteBtnHov_btn__TCeIT"};